import React from 'react'

//  Styles
import styles from './Exhibit5.module.scss';

//  Images
import costs_2013 from "../../../assets/img/exhibit5/costs-2013.png"
import costs_2014 from "../../../assets/img/exhibit5/costs-2014.png"
import costs_2015 from "../../../assets/img/exhibit5/costs-2015.png"
import costs_2016 from "../../../assets/img/exhibit5/costs-2016.png"
import costs_2017 from "../../../assets/img/exhibit5/costs-2017.png"
import uninsured_2013 from "../../../assets/img/exhibit5/uninsured-2013.png"
import uninsured_2014 from "../../../assets/img/exhibit5/uninsured-2014.png"
import uninsured_2015 from "../../../assets/img/exhibit5/uninsured-2015.png"
import uninsured_2016 from "../../../assets/img/exhibit5/uninsured-2016.png"
import uninsured_2017 from "../../../assets/img/exhibit5/uninsured-2017.png"

const costImages = {
  "2013": costs_2013,
  "2014": costs_2014,
  "2015": costs_2015,
  "2016": costs_2016,
  "2017": costs_2017
}

const uninsuredImages = {
  "2013": uninsured_2013,
  "2014": uninsured_2014,
  "2015": uninsured_2015,
  "2016": uninsured_2016,
  "2017": uninsured_2017
}

const years = [
  "2013",
  "2014",
  "2015",
  "2016",
  "2017"
]

class Exhibit5 extends React.Component {

  state = { currentYear: "2013" };

  handleClick(year, e) {
    this.setState({ currentYear: year })
    e.preventDefault();
  }

  render() {
    
    const {currentYear} = this.state;

    return (
      <figure>
        <h2 className="title__block">Cost barriers to receiving care fell as uninsured rates fell following ACA coverage expansions</h2>
        <div className="instructions">
          <ul>
            <li>Select a year to see changes over time.</li>
          </ul>
        </div>
        <nav className={ styles.year__nav }>
          <ul className={ [styles.year__list, styles[`year__list__${currentYear}`]].join(" ") }>
            { years.map(year => (
              <li key={ year } className={[currentYear === year ? styles.year__list__item__active : "" , styles.year__list__item].join(" ")}>
                <a href={`#year_${year}`} aria-controls={`#year_${year}`} onClick={(e) => this.handleClick(year, e) }>{ year }</a>
              </li>
            ))}
          </ul>
        </nav>
        <div className={ styles.images }>
          <ul className={ styles.image__list }>
            { years.map(year => (<li key={ year } id={`year_${year}`} className={ styles.image__list__year } aria-hidden={currentYear === year ? false: true }>
              <div className={ [styles.map, styles.map__cost].join(" ") }>
                <h3>Uninsured adults</h3>
                <figure>
                  <img src={ uninsuredImages[year] } alt="" />
                  <figcaption>
                    { year }
                  </figcaption>
                </figure>
              </div>
              <div className={ [styles.map, styles.map__uninsured].join(" ") }>
                <h3>Adults who went without care because of costs</h3>
                <figure>
                  <img src={ costImages[year] } alt="" />
                  <figcaption>
                    { year }
                  </figcaption>
                </figure>
              </div>
            </li>))}
          </ul>
          <ul className={ styles.legend }>
            <li className={ styles.legend__light }>Less than 10%</li>
            <li className={ styles.legend__medium }>10%-14%</li>
            <li className={ styles.legend__dark }>15% or more</li>
          </ul>
        </div>
        <figcaption>
          <p>Notes: Adults who went without care is limited to adults ages 18–64 in this exhibit, though the Scorecard ranks states on a version of this measure that includes all adults age 18 and older.</p>
          <p>Data: Uninsured (ages 19–64): U.S. Census Bureau, 2013–2017 One-Year American Community Surveys, Public Use Micro Sample (ACS PUMS); Cost barriers (ages 18–64): 2013–2017 Behavioral Risk Factor Surveillance System (BRFSS).</p>
        </figcaption>
      </figure>
    )
  }
}

export default Exhibit5


// WEBPACK FOOTER //
// ./src/components/Exhibits/Exhibit5/Exhibit5.js